import React, { useState } from "react";
import {FaEye, FaEyeSlash} from "react-icons/fa";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";
import {BASE_URL} from "./Constants";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    email: "",
    otp: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState();
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Step 1: Send OTP
  const sendOtp = async () => {
    if (!formData.email) return alert("Email is required");

     //email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(formData.email)) {
        return alert("Please enter a valid email address")
    }


    try {
      const res = await fetch(`${BASE_URL}/send_otp`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formData.email, context: "forgot_password" }),
        
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to send OTP");
      setMessage("OTP sent to email");
      setStep(2);
    } catch (err) {
      setMessageType("error")
      setMessage(err.message);
    }
  };

  // Step 2: Validate OTP
  const validateOtp = async () => {
    if (!formData.otp) return alert("OTP is required");

    try {
      const res = await fetch(`${BASE_URL}/validate_otp`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formData.email, otp: formData.otp }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Invalid OTP");
      setMessage("OTP verified! Please reset your password.");
      setStep(3);
    } catch (err) {
      setMessageType("error")
      setMessage(err.message);
    }
  };

  // Step 3: Reset password
  const resetPassword = async () => {
    console.log("Reset Password Data:", formData); // <-- check values
    if (!formData.newPassword || !formData.confirmPassword)
      return setMessage("All fields are required");
    if (formData.newPassword !== formData.confirmPassword)
      return setMessage("Passwords do not match");

    try {
      const res = await fetch(`${BASE_URL}/reset_password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
        email: formData.email,
        new_password: formData.newPassword,   
        confirm_password: formData.confirmPassword, 
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to reset password");
      setMessage("Password reset successfully!");
      navigate("/checkout/login");
      setStep(1);
    } catch (err) {
      setMessage(err.message);
    }
  };


  return (
    <>
        <div className="forgot-password-container">
        <h2>Forgot Password</h2>

        {step === 1 && (
            <div>
            <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
            />
            <button onClick={sendOtp}>Send OTP</button>

            {message && (
              <p className={`msg ${messageType}`}>{message}</p>
            )}
            </div>
        )}

        
        {step === 2 && (
            <div>
            <input
                type="text"
                name="otp"
                placeholder="Enter OTP"
                value={formData.otp}
                onChange={handleChange}
            />
            {message && (
              <p className={`msg ${messageType}`}>{message}</p>
            )}
            <button onClick={validateOtp}>Verify OTP</button>
            </div>
        )}

        {step === 3 && (
          <div className="password">
              <div className="password-field">
                <input
                  type={showPassword ? "text" : "password"}
                  name="newPassword"
                  placeholder="New Password"
                  value={formData.newPassword}
                  onChange={handleChange}
                />
                <span
                  className="eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: "pointer" }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

                <div className="password-field">
                    <input
                    type={showPassword ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    />
                    <span
                    className="eye-icon"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ cursor: "pointer" }}
                    >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                </div>

                <button onClick={resetPassword}>Reset Password</button>

                {message && (
                  <p className={`msg ${messageType}`}>{message}</p>
                )}
            </div>

        )}
        </div>
        <Footer/>
    </>
  );
};

export default ForgotPassword;
